var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectorRef, ElementRef, EventEmitter, Renderer2 } from '@angular/core';
import { AchooInputComponent } from '../../../core/achoo-input/achoo-input.component';
import { GroupService } from '../../../services/group-details/group.service';
import { catchError, debounceTime, distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { CommonConstant, listOrderedPlatforms } from '../../../app.constants';
import { ValidationHandlerService } from '../../../core/validation-handler.service';
import { NgSelectComponent } from '@ng-select/ng-select';
var AutoSuggestionInfluencerComponent = /** @class */ (function (_super) {
    __extends(AutoSuggestionInfluencerComponent, _super);
    function AutoSuggestionInfluencerComponent(groupService, cd, validationHandlerService, renderer, elementRef) {
        var _this = _super.call(this, validationHandlerService) || this;
        _this.groupService = groupService;
        _this.cd = cd;
        _this.validationHandlerService = validationHandlerService;
        _this.renderer = renderer;
        _this.elementRef = elementRef;
        _this.numberSelectedInfluencer = 0;
        _this.selectInfluencerEvent = new EventEmitter();
        _this.enterEvent = new EventEmitter();
        _this.afterLoadingSuggestion = new EventEmitter();
        _this.addNewInfluencer = new EventEmitter();
        _this.suggestionLoading = false;
        _this.hasErrorWhenSearching = false;
        _this.typeahead = new EventEmitter();
        _this.platformList = [];
        _this.numberOfItemsFromEndBeforeFetchingMore = 10;
        _this.platformList = listOrderedPlatforms;
        renderer.listen(elementRef.nativeElement, 'keyup', function (evt) {
            if (evt.code === CommonConstant.ENTER_CODE && !_this.suggestionLoading
                && Array.isArray(_this.suggestionInfluencers) && _this.suggestionInfluencers.length > 0) {
                // waiting for 200ms before emitting. Because time debounce of auto complete is set 200ms
                setTimeout(function () {
                    _this.enterEvent.emit({
                        handle: _this.searchQuery,
                        isLoading: _this.suggestionLoading,
                        suggestionList: _this.suggestionInfluencers
                    });
                }, 200);
            }
        });
        _this.typeahead.pipe(distinctUntilChanged(), debounceTime(200), tap(function () {
            _this.hasErrorWhenSearching = false;
            _this.suggestionLoading = true;
            _this.suggestionInfluencers = [];
            _this.scrollId = undefined;
        }), switchMap(function (term) { return _this.loadSuggestion(term); })).subscribe(function (res) {
            _this.suggestionInfluencers = res;
            _this.afterLoadingSuggestion.emit({
                suggestionList: res,
                hasError: _this.hasErrorWhenSearching
            });
        });
        return _this;
    }
    AutoSuggestionInfluencerComponent.prototype.loadSuggestion = function (term, matchExtractly) {
        var _this = this;
        this.searchQuery = term;
        return this.groupService.loadInfluencerSuggestion(term, this.scrollId).pipe(catchError(function (err) {
            // WS will throw 404 error when there is no influencer match with term
            // So, ignore this error
            if (err.status !== 404) {
                _this.hasErrorWhenSearching = true;
            }
            return Observable.of([]);
        }), map(function (items) {
            _this.scrollId = items.scrollId;
            _this.totalResults = items.totalResults;
            if (items && items.influencers) {
                if (matchExtractly) {
                    return items.influencers.filter(function (item) { return item.channels.filter(function (c) { return c.handle === term; }).length > 0; });
                }
                return items.influencers;
            }
            else {
                return [];
            }
        }), tap(function () { return _this.suggestionLoading = false; }));
    };
    AutoSuggestionInfluencerComponent.prototype.onScroll = function (_a) {
        var end = _a.end;
        if (this.suggestionLoading || this.totalResults === this.suggestionInfluencers.length) {
            return;
        }
        if (end + this.numberOfItemsFromEndBeforeFetchingMore >= this.suggestionInfluencers.length) {
            this.fetchMore();
        }
    };
    AutoSuggestionInfluencerComponent.prototype.onScrollEnd = function () {
        this.fetchMore();
    };
    AutoSuggestionInfluencerComponent.prototype.fetchMore = function () {
        var _this = this;
        this.suggestionLoading = true;
        this.loadSuggestion(this.searchQuery).subscribe(function (res) {
            _this.suggestionLoading = false;
            _this.suggestionInfluencers = _this.suggestionInfluencers.concat(res);
        });
    };
    AutoSuggestionInfluencerComponent.prototype.onSelectSuggestion = function (e) {
        this.selectInfluencerEvent.emit(e);
        this.suggestionInfluencers = [];
    };
    AutoSuggestionInfluencerComponent.prototype.getCountryCode = function (influencer) {
        return influencer && influencer.country && influencer.country.code ? influencer.country.code.toLowerCase() : CommonConstant.INTERNATION_COUNTRY_CODE;
    };
    AutoSuggestionInfluencerComponent.prototype.hasPlatform = function (platformId, influencer) {
        if (!influencer || !influencer.channels) {
            return false;
        }
        return influencer.channels.findIndex(function (channel) { return channel.platform && channel.platform.id === platformId; }) >= 0;
    };
    AutoSuggestionInfluencerComponent.prototype.openSuggestionDropdown = function (handle, matchExtractly) {
        var _this = this;
        if (matchExtractly === void 0) { matchExtractly = true; }
        // filter suggestion by handle
        var term = handle.replace('@', '');
        this.ngSelectComp.open();
        this.suggestionInfluencers = [];
        this.suggestionLoading = true;
        this.loadSuggestion(term, matchExtractly).subscribe(function (res) {
            _this.suggestionInfluencers = res;
        });
    };
    AutoSuggestionInfluencerComponent.prototype.addNewInfluencerManually = function () {
        this.addNewInfluencer.emit({
            handle: this.searchQuery,
            index: -1,
            influencer: null,
        });
    };
    Object.defineProperty(AutoSuggestionInfluencerComponent.prototype, "canShowAddNewInfluencerLine", {
        get: function () {
            return this.suggestionInfluencers && this.suggestionInfluencers.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    return AutoSuggestionInfluencerComponent;
}(AchooInputComponent));
export { AutoSuggestionInfluencerComponent };



// WEBPACK FOOTER //
// ./src/app/main/group-details/auto-suggestion-influencer/auto-suggestion-influencer.component.ts.pre-build-optimizer.js